// import React, { useState } from "react";
// import Select from "react-select";
// import { Link } from "react-router-dom";

// const options = [
//     { value: "dashboard", label: "Dashboard" },
//     { value: "team", label: "My Team" },
//     { value: "buildings", label: "Buildings" },
//     { value: "reports", label: "Reports" },
// ];

// const properties = [
//     {
//         id: 1,
//         buildingName: "Office Complex A",
//         ownerName: "Alex Johns",
//         address: "123 Business St, City",
//         propertyType: "Office",
//         status: "Active",
//         periods: [
//             { from: "08/22/2022", to: "08/22/2023" },
//             { from: "09/01/2023", to: "09/01/2024" },
//             { from: "09/01/2023", to: "09/01/2024" },
//             { from: "09/01/2023", to: "09/01/2024" },
//         ],
//     },
//     {
//         id: 2,
//         buildingName: "Residential Tower B",
//         ownerName: "Sarah Lee",
//         address: "45 Park Ave, City",
//         propertyType: "Residential",
//         status: "Inactive",
//         periods: [
//             { from: "01/01/2021", to: "01/01/2022" },
//             { from: "02/01/2022", to: "02/01/2023" },
//         ],
//     },
//     {
//         id: 3,
//         buildingName: "Mall Center C",
//         ownerName: "Michael Smith",
//         address: "77 Downtown Rd, City",
//         propertyType: "Commercial",
//         status: "Active",
//         periods: [
//             { from: "03/15/2022", to: "03/15/2023" },
//             { from: "04/10/2023", to: "04/10/2024" },
//         ],
//     },
//     {
//         id: 4,
//         buildingName: "Office Complex A",
//         ownerName: "Alex Johns",
//         address: "123 Business St, City",
//         propertyType: "Office",
//         status: "Active",
//         periods: [
//             { from: "08/22/2022", to: "08/22/2023" },
//             { from: "09/01/2023", to: "09/01/2024" },
//             { from: "09/01/2023", to: "09/01/2024" },
//             { from: "09/01/2023", to: "09/01/2024" },
//         ],
//     },
//     {
//         id: 5,
//         buildingName: "Residential Tower B",
//         ownerName: "Sarah Lee",
//         address: "45 Park Ave, City",
//         propertyType: "Residential",
//         status: "Inactive",
//         periods: [
//             { from: "01/01/2021", to: "01/01/2022" },
//             { from: "02/01/2022", to: "02/01/2023" },
//         ],
//     },
//     {
//         id: 6,
//         buildingName: "Mall Center C",
//         ownerName: "Michael Smith",
//         address: "77 Downtown Rd, City",
//         propertyType: "Commercial",
//         status: "Active",
//         periods: [
//             { from: "03/15/2022", to: "03/15/2023" },
//             { from: "04/10/2023", to: "04/10/2024" },
//         ],
//     },
// ];

// const Buildings = () => {
//     const [selectedOption, setSelectedOption] = useState(null);

//     return (
//         <div className="admin-page">
//             <div className="admin-page-title d-flex align-items-center justify-content-between">
//                 <h1 className="page-section-title">Buildings</h1>
//                 <Link to="/buildings/create-building" className="btns">
//                     <i className="icon-icon-5"></i>
//                     Create Building
//                 </Link>
//             </div>

//             <div className="buildings-filter d-flex align-items-center">
//                 <div className="form-group mb-0">
//                     <label>Search</label>
//                     <div className="search-icon">
//                         <i className="icon-icon-6"></i>
//                         <input className="form-control" placeholder="Search buildings" />
//                     </div>
//                 </div>
//                 <div className="form-row d-flex">
//                     <div className="form-group mb-0">
//                         <label>Property Type</label>
//                         <div className="custom-select">
//                             <Select
//                                 options={options}
//                                 value={selectedOption}
//                                 onChange={setSelectedOption}
//                                 placeholder="All Types"
//                                 isClearable
//                             />
//                         </div>
//                     </div>
//                     <div className="form-group mb-0">
//                         <label>Status</label>
//                         <div className="custom-select">
//                             <Select
//                                 options={options}
//                                 value={selectedOption}
//                                 onChange={setSelectedOption}
//                                 placeholder="All Status"
//                                 isClearable
//                             />
//                         </div>
//                     </div>
//                 </div>
//             </div>
//             <div className="properties-listing">
//                 <h3 className="page-section-title mb-6">Properties Listing</h3>
//                 <div className="common-table">
//                     <div className="table-wrpper">
//                         <table>
//                             <thead>
//                                 <tr>
//                                     <th>Building Name</th>
//                                     <th>Owner Name</th>
//                                     <th>Address</th>
//                                     <th>Property Type</th>
//                                     <th>Status</th>
//                                     <th>Actions</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {properties.map((property) => (
//                                     <React.Fragment key={property.id}>
//                                         <tr>
//                                             <td>{property.buildingName}</td>
//                                             <td>{property.ownerName}</td>
//                                             <td>{property.address}</td>
//                                             <td>{property.propertyType}</td>
//                                             <td>
//                                                 <p className="status">{property.status}</p>
//                                             </td>
//                                             <td>
//                                                 <div className="d-flex button-group">
//                                                     <Link to="/buildings/building-details" className="btns-table view-btn">
//                                                         <i className="icon-icon-1"></i>
//                                                         View
//                                                     </Link>
//                                                     <Link to="/buildings/create-building" className="btns-table edit-btn">
//                                                         <i className="icon-icon-8"></i>
//                                                         Edit
//                                                     </Link>
//                                                 </div>
//                                             </td>
//                                         </tr>
//                                         <tr className="period-tr">
//                                             <td colSpan={6}>
//                                                 <div className="period-item d-flex">
//                                                     <p>Period</p>
//                                                     <ul className="d-flex align-items-center flex-wrap">
//                                                         {property.periods.map((period, idx) => (
//                                                             <li key={idx}>
//                                                                 <span>{period.from}</span> to{" "}
//                                                                 <span>{period.to}</span>
//                                                             </li>
//                                                         ))}
//                                                     </ul>
//                                                 </div>
//                                             </td>
//                                         </tr>
//                                     </React.Fragment>
//                                 ))}
//                             </tbody>
//                         </table>
//                     </div>
//                 </div>
//                 <div className="table-pagination d-flex align-items-center justify-content-between gap-2 mt-4">
//                     <div className="pagination-info">
//                         Showing 1 - 5 of 200                    </div>
//                     <div className="pagination-controls d-flex align-items-center">
//                         <button className="btns-table prev-btn"><i className="icon-icon-10"></i></button>
//                         <button className="btns-table next-btn" ><i className="icon-icon-9"></i></button>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// }

// export default Buildings;

import React, { useEffect, useState } from "react";
import Select from "react-select";
import { Link } from "react-router-dom";
import axios from "axios";

const propertyTypeOptions = [
  { value: "All", label: "All Types" },
  { value: "office", label: "Office" },
  { value: "retail", label: "Retail" },
  { value: "warehouse", label: "Warehouse" },
  { value: "residential", label: "Residential" },
];

// Client 2026-09-11: three property statuses. Inactive and Training behave the
// same (both out of the Dashboard totals); the labels only tell a contract that
// ended apart from a training copy.
const statusOptions = [
  { value: "All", label: "All Status" },
  { value: "Active", label: "Active" },
  { value: "Inactive", label: "Inactive" },
  { value: "Training", label: "Training" },
];

// Columns the listing can be ordered by. `key` must match the backend whitelist.
const sortableColumns = [
  { key: "building_name", label: "Building Name" },
  { key: "owner_name", label: "Owner Name" },
  { key: "building_address", label: "Address" },
  { key: "property_type", label: "Property Type" },
  { key: "status", label: "Status" },
];

const Buildings = () => {
  const [buildings, setBuildings] = useState([]);
  const [search, setSearch] = useState("");
  const [propertyType, setPropertyType] = useState({ value: "All", label: "All Types" });
  const [status, setStatus] = useState({ value: "All", label: "All Status" });
  const [page, setPage] = useState(1);
  // Client 2026-09-15: "display more than 10 lines … we can go for 100".
  // 100 by default, with a selector so a long list can still be cut down.
  const [pageSize, setPageSize] = useState(100);
  const [pagination, setPagination] = useState({ total: 0, totalPages: 0 });
  // Sorting is applied by the server across the whole list, not just the page on
  // screen. Default Building Name A→Z, as agreed with the client.
  const [sortBy, setSortBy] = useState("building_name");
  const [sortDir, setSortDir] = useState("asc");
  // id of the row whose status is being saved, so only that dropdown locks
  const [statusSavingId, setStatusSavingId] = useState(null);

  // Duplicate-building dialog (client 2026-09-09). Exactly ONE period per
  // duplicate — the client duplicates a single year and then adds further periods
  // inside the new building with the existing "Copy Period" button.
  const [duplicateTarget, setDuplicateTarget] = useState(null); // the source building
  const [duplicateName, setDuplicateName] = useState("");
  const [duplicatePeriod, setDuplicatePeriod] = useState(null);
  const [duplicating, setDuplicating] = useState(false);
  const [duplicateError, setDuplicateError] = useState(null);

  // Fetch Buildings
  const fetchBuildings = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}building/list`, {
        headers: {
          "api-key": process.env.REACT_APP_API_KEY,
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        params: {
          page,
          pageSize,
          search,
          propertyType: propertyType?.value || "All",
          status: status?.value || "All",
          sortBy,
          sortDir,
        },
      });

      if (res.data.status === "success") {
        const list = res.data.data.buildings || [];
        setBuildings(list);
        setPagination(res.data.data.pagination);
        // Changing a status (or deleting) can empty the page you are standing on —
        // e.g. the last Active row on page 2 becomes Training while the Active
        // filter is applied. Drop back rather than showing an empty table.
        if (list.length === 0 && page > 1) setPage(1);
      } else {
        setBuildings([]);
      }
    } catch (err) {
      console.error("Error fetching buildings:", err);
    }
  };

  useEffect(() => {
    fetchBuildings();
  }, [page, pageSize, search, propertyType, status, sortBy, sortDir]);

  // Clicking a header sorts by it ascending, clicking the same header again flips
  // the direction. Always jump back to page 1 — staying on page 4 of a re-sorted
  // list shows the user rows that have nothing to do with what they clicked.
  const handleSort = (key) => {
    if (sortBy === key) {
      setSortDir((d) => (d === "asc" ? "desc" : "asc"));
    } else {
      setSortBy(key);
      setSortDir("asc");
    }
    setPage(1);
  };

  // Delete Building Handler
  const handleDeleteBuilding = async (buildingId, buildingName) => {
    const confirmDelete = window.confirm(
      `Are you sure you want to delete "${buildingName}"?\n\nThis will permanently delete:\n• The building\n• All time periods\n• All imported data (costs, surfaces, consumptions)\n• All keys associated with this building\n\nThis action cannot be undone.`
    );

    if (!confirmDelete) return;

    try {
      const res = await axios.delete(`${process.env.REACT_APP_API_URL}building/delete/${buildingId}`, {
        headers: {
          "api-key": process.env.REACT_APP_API_KEY,
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      if (res.data.status === "success") {
        alert("Building deleted successfully!");
        fetchBuildings(); // Refresh the list
      } else {
        alert(res.data.message || "Failed to delete building");
      }
    } catch (err) {
      console.error("Error deleting building:", err);
      const errorMsg = err?.response?.data?.message || err?.response?.data?.data || "Failed to delete building";
      alert(errorMsg);
    }
  };

  // Change a property's status straight from the listing. Only "Active" counts in
  // the Dashboard totals; Inactive and Training behave identically.
  const handleStatusChange = async (building, newStatus) => {
    const previous = building.status_value || (building.is_active ? "active" : "inactive");
    if (newStatus === previous) return;

    setStatusSavingId(building.id);
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}building/update`,
        { id: building.id, status: newStatus },
        {
          headers: {
            "api-key": process.env.REACT_APP_API_KEY,
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (res.data.status === "success") {
        // Refetch rather than patching the row in place: with a Status filter or a
        // sort on Status applied, the row may now belong on a different page — or
        // not in the list at all.
        fetchBuildings();
      } else {
        alert(res.data.message || res.data.data || "Failed to update status");
      }
    } catch (err) {
      console.error("Error updating status:", err);
      alert(
        err?.response?.data?.data ||
        err?.response?.data?.message ||
        "Failed to update status"
      );
    } finally {
      setStatusSavingId(null);
    }
  };

  // Duplicate Building Handlers
  const periodOptionsFor = (building) =>
    (building?.periods || []).map((period, idx) => ({
      value: period.id,
      label: `Period ${idx + 1}: ${period.from} to ${period.to}`,
    }));

  const openDuplicateModal = (building) => {
    const options = periodOptionsFor(building);
    setDuplicateTarget(building);
    setDuplicateName(`${building.building_name} - Copy`);
    // Pre-select when there is only one period, so the common case is one click.
    setDuplicatePeriod(options.length === 1 ? options[0] : null);
    setDuplicateError(null);
  };

  const closeDuplicateModal = () => {
    if (duplicating) return;
    setDuplicateTarget(null);
    setDuplicateName("");
    setDuplicatePeriod(null);
    setDuplicateError(null);
  };

  const handleDuplicateBuilding = async (e) => {
    e.preventDefault();
    if (!duplicateTarget) return;

    const name = duplicateName.trim();
    if (!name) {
      setDuplicateError("Please enter a name for the new building.");
      return;
    }
    if (!duplicatePeriod?.value) {
      setDuplicateError("Please select the period to duplicate.");
      return;
    }

    setDuplicating(true);
    setDuplicateError(null);
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}building/duplicate`,
        {
          source_building_id: duplicateTarget.id,
          source_period_id: duplicatePeriod.value,
          building_name: name,
        },
        {
          headers: {
            "api-key": process.env.REACT_APP_API_KEY,
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (res.data.status === "success") {
        setDuplicateTarget(null);
        setDuplicateName("");
        setDuplicatePeriod(null);
        // Calculations are rebuilt in the background, hence "within a few seconds".
        alert(
          `"${name}" was created from ${duplicateTarget.building_name}.\n\n` +
          `Its calculations are being rebuilt and will be ready within a few seconds.`
        );
        fetchBuildings();
      } else {
        setDuplicateError(res.data.message || res.data.data || "Failed to duplicate building");
      }
    } catch (err) {
      console.error("Error duplicating building:", err);
      setDuplicateError(
        err?.response?.data?.data ||
        err?.response?.data?.message ||
        "Failed to duplicate building"
      );
    } finally {
      setDuplicating(false);
    }
  };

  return (
    <div className="admin-page">
      <div className="admin-page-title d-flex align-items-center justify-content-between">
        <h1 className="page-section-title">Buildings</h1>
        <Link to="/buildings/create-building" className="btns">
          <i className="icon-icon-5"></i>
          Create Building
        </Link>
      </div>

      {/* Filters */}
      <div className="buildings-filter d-flex align-items-center">
        <div className="form-group mb-0">
          <label>Search</label>
          <div className="search-icon">
            <i className="icon-icon-6"></i>
            <input
              className="form-control"
              placeholder="Search buildings"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
        </div>
        <div className="form-row d-flex">
          <div className="form-group mb-0">
            <label>Property Type</label>
            <div className="custom-select">
              <Select
                options={propertyTypeOptions}
                value={propertyType}
                onChange={setPropertyType}
                placeholder="All Types"
                isClearable
              />
            </div>
          </div>
          <div className="form-group mb-0">
            <label>Status</label>
            <div className="custom-select">
              <Select
                options={statusOptions}
                value={status}
                onChange={(opt) => { setStatus(opt); setPage(1); }}
                placeholder="All Status"
                isClearable
              />
            </div>
          </div>
        </div>
      </div>

      {/* Table */}
      <div className="properties-listing">
        <h3 className="page-section-title mb-6">Properties Listing</h3>
        <div className="common-table">
          <div className="table-wrpper">
            <table>
              <thead>
                <tr>
                  {sortableColumns.map((col) => (
                    <th
                      key={col.key}
                      className={`sortable-th${sortBy === col.key ? " sorted" : ""}`}
                      onClick={() => handleSort(col.key)}
                      title={`Sort by ${col.label}`}
                      aria-sort={sortBy === col.key ? (sortDir === "asc" ? "ascending" : "descending") : "none"}
                    >
                      {col.label}
                      <span className="sort-arrow">
                        {sortBy === col.key ? (sortDir === "asc" ? "▲" : "▼") : "⇅"}
                      </span>
                    </th>
                  ))}
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {buildings.map((building) => (
                    <React.Fragment key={building.id}>
                    <tr>
                        <td>{building.building_name}</td>
                        <td>{building.owner_name}</td>
                        <td>{building.building_address || building.property_address}</td>
                        <td>{building.property_type}</td>
                        <td>
                        <select
                            className={`status status-select ${building.status_value || (building.is_active ? "active" : "inactive")}`}
                            value={building.status_value || (building.is_active ? "active" : "inactive")}
                            onChange={(e) => handleStatusChange(building, e.target.value)}
                            disabled={statusSavingId === building.id}
                            title="Only Active properties count in the Dashboard totals"
                        >
                            <option value="active">Active</option>
                            <option value="inactive">Inactive</option>
                            <option value="training">Training</option>
                        </select>
                        </td>
                        <td>
                        <div className="d-flex button-group">
                            <Link
                            to={`/buildings/building-details/${building.id}`}
                            className="btns-table view-btn"
                            >
                            <i className="icon-icon-1"></i>
                            View
                            </Link>
                            <Link
                            to={`/buildings/edit/${building.id}`}
                            className="btns-table edit-btn"
                            >
                            <i className="icon-icon-8"></i>
                            Edit
                            </Link>
                            <button
                            onClick={() => openDuplicateModal(building)}
                            className="btns-table edit-btn"
                            title="Create an independent copy of this building for one period"
                            disabled={!building.periods?.length}
                            >
                            <i className="icon-icon-12"></i>
                            Duplicate
                            </button>
                            <button
                            onClick={() => handleDeleteBuilding(building.id, building.building_name)}
                            className="btns-table delete-btn"
                            >
                            <i className="icon-icon-14"></i>
                            Delete
                            </button>
                        </div>
                        </td>
                    </tr>

                    {building.periods?.length > 0 && (
                        <tr className="period-tr">
                        <td colSpan={6}>
                            <div className="period-item d-flex">
                            <p>Period</p>
                            <ul className="d-flex align-items-center flex-wrap">
                                {building.periods.map((period) => (
                                <li key={period.id}>
                                    <span>{period.from}</span> to <span>{period.to}</span>
                                </li>
                                ))}
                            </ul>
                            </div>
                        </td>
                        </tr>
                    )}
                    </React.Fragment>
                ))}
                </tbody>
            </table>
          </div>
        </div>

        {/* Pagination */}
        <div className="table-pagination d-flex align-items-center justify-content-between gap-2 mt-4">
          <div className="pagination-info d-flex align-items-center gap-3">
            <span>
              Showing {pagination.total === 0 ? 0 : (page - 1) * pageSize + 1} -{" "}
              {Math.min(page * pageSize, pagination.total)} of {pagination.total}
            </span>
            <label className="rows-per-page d-flex align-items-center gap-2 mb-0">
              Rows
              <select
                className="form-control"
                value={pageSize}
                onChange={(e) => { setPageSize(Number(e.target.value)); setPage(1); }}
              >
                {[25, 50, 100, 200].map((n) => (
                  <option key={n} value={n}>{n}</option>
                ))}
              </select>
            </label>
          </div>
          <div className="pagination-controls d-flex align-items-center">
            <button
              className="btns-table prev-btn"
              onClick={() => setPage((p) => Math.max(p - 1, 1))}
              disabled={page === 1}
            >
              <i className="icon-icon-10"></i>
            </button>
            <button
              className="btns-table next-btn"
              onClick={() => setPage((p) => Math.min(p + 1, pagination.totalPages))}
              disabled={page === pagination.totalPages}
            >
              <i className="icon-icon-9"></i>
            </button>
          </div>
        </div>
      </div>

      {/* Duplicate Building Modal */}
      {duplicateTarget && (
        <div
          className="modal fade show"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
          onClick={(e) => { if (e.target === e.currentTarget) closeDuplicateModal(); }}
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  Duplicate — {duplicateTarget.building_name}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={closeDuplicateModal}
                  disabled={duplicating}
                />
              </div>

              <form onSubmit={handleDuplicateBuilding} noValidate>
                <div className="modal-body">
                  <div className="form-group mb-3">
                    <label htmlFor="duplicate-building-name">
                      New building name <span className="text-danger ms-1">*</span>
                    </label>
                    <input
                      id="duplicate-building-name"
                      type="text"
                      className="form-control"
                      value={duplicateName}
                      onChange={(e) => setDuplicateName(e.target.value)}
                      placeholder="e.g. Training Étang B"
                      disabled={duplicating}
                      autoFocus
                    />
                  </div>

                  <div className="form-group mb-3">
                    <label>
                      Period to duplicate <span className="text-danger ms-1">*</span>
                    </label>
                    <div className="custom-select">
                      <Select
                        options={periodOptionsFor(duplicateTarget)}
                        value={duplicatePeriod}
                        onChange={setDuplicatePeriod}
                        placeholder="Select a period"
                        isDisabled={duplicating}
                      />
                    </div>
                  </div>

                  <p className="mb-0 text-muted">
                    All data of the selected period is copied — costs and invoices,
                    surfaces, consumptions, DJF / NJ / ETC, objects and tenants, and
                    every key with its formulas, destinations, ponderations and buyers.
                    The new building is fully independent from{" "}
                    {duplicateTarget.building_name}. You can add further periods to it
                    afterwards with the "Copy Period" button.
                  </p>

                  {duplicateError && (
                    <div className="alert alert-danger mt-3 mb-0">{duplicateError}</div>
                  )}
                </div>

                <div className="modal-footer">
                  <button
                    type="button"
                    className="btns-cancel"
                    onClick={closeDuplicateModal}
                    disabled={duplicating}
                  >
                    Cancel
                  </button>
                  <button type="submit" className="btns" disabled={duplicating}>
                    {duplicating ? "Duplicating…" : "Duplicate"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Buildings;